import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const LiveAuctionNav = ({ tabsList }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState(location.pathname);


    useEffect(() => {
        setSelectedOption(location.pathname);
    }, [location]);

    const handleChange = (value) => {
        setSelectedOption(value);
        navigate(value);
    };

    const tabs = tabsList ? tabsList :
        [
            { label: 'Auction', value: '/admin/AuctionInventory' },
        ];

    return (
        <div className="inventory-nav-container">
            <div className="tabs">
                {tabs.map((tab) => (
                    <div
                        key={tab.value}
                        className={`tab ${selectedOption.startsWith(tab.value) ? 'active' : ''}`}
                        onClick={() => handleChange(tab.value)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LiveAuctionNav;